import { Component, OnInit, Input } from '@angular/core';
import { Image } from '../services/kla.data.models';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';
import { InspectImageDirective } from 'app/shared/directives/image-inspect.directive';

@Component({
  selector: 'kla-image-object',
  templateUrl: './image-object.component.html',
  styleUrls: ['./image-object.component.scss'],
  standalone: true,
  imports: [ CommonModule, DynamicContentComponent, InspectImageDirective ]
})
export class ImageObjectComponent implements OnInit {

  @Input() imageObject: Image;
  @Input() imageClass: string;
  @Input() captionColor = '#474747';
  @Input() imageHeight: string | number;
  @Input() imageWidth: string | number;

  imagePath: string;

  constructor(
    private httpService: KlaHttpService
  ) { }

  setFigureStyles() {
    let styles = {
      'max-width': `${this.imageWidth}`,
      'max-height': `${this.imageHeight}`,
    }
    return styles;
  }
  setImageStyles() {
    let styles = {
      'max-width': `${this.imageWidth}`,
      'max-height': `${this.imageHeight}`,
    }
    return styles;
  }

  ngOnInit() {
    if (this.imageObject.cropConfig && (this.imageObject.width || this.imageObject.height)) {
      this.imagePath = this.httpService.getCroppedImagePath(this.imageObject);
    } else {
      this.imagePath = this.httpService.getImagePath(this.imageObject.id, this.imageObject.width);
    }
  }

}
